import { AppVersionNumber } from "../components/organism/AppVersion";
import { analytics, routePaths } from "../constants/analytics";
import { browserDetails, checkDeviceType, getOS } from "./deviceUtilities";

export const gaEvent = (event, persistItemsReducer = {}) => {

    function getPartialMatchingRoute(pathname, routes) {
        return routes.find(route => pathname.includes(route));
    }

    const params = (event === "PageView") ? {
        "portal_page_event": "page_view",
        "portal_version": AppVersionNumber,
        "browser": browserDetails()?.browserName,
        "browser_version": browserDetails()?.fullVersion,
        "platform_os": getOS(),
        "device": checkDeviceType(),
        "sponsor_id": persistItemsReducer?.sponsorID,
        "page_path": getPartialMatchingRoute(window.location.pathname, routePaths),
        "page_url": getPartialMatchingRoute(window.location.href, routePaths),
    } : {
        "portal_cta_event": analytics[event]?.ID,
        "portal_screen_name": analytics[event]?.portal_screen_name,
        "portal_section": analytics[event]?.portal_section,
        "portal_sub_section": analytics[event]?.portal_sub_section,
        "portal_cta_label_text": analytics[event]?.portal_cta_label_text,
        "Portal_event_description": analytics[event]?.Portal_event_description,
        "sponsor_id": persistItemsReducer?.sponsorID,
        "action_success": "",
        "action_failed": "",
        "Islogged_in": persistItemsReducer?.isLoggedIn,
        "page_path": getPartialMatchingRoute(window.location.pathname, routePaths),
        "page_url": getPartialMatchingRoute(window.location.href, routePaths),
    }
    try {
        window.dataLayer = window.dataLayer || [];
        if (event === "PageView") {
            window.dataLayer.push({ ...{ "event": "page_view" }, ...params });
        } else {
            window.dataLayer.push({ ...{ "event": "generic_click" }, ...params });
        }
        // console.table("dataLayer", window.dataLayer);
    } catch (err) {
        // TODO : Error should be handled through DB logs or analytics
        console.log("analytics error", err);
    }
}

export const getGTMId = (soName) => {
    try {
        let gtmID = "";
        switch (soName) {
            case "auto":
                gtmID = window.location.host === "portal.wvmobile.org" ? "GTM-THR844WP" : "GTM-5JW8MTC9";
                break;
            case "fino":
                gtmID = window.location.host === "portal.wvmobile.org" ? "GTM-MXDRJZBJ" : "GTM-54BHS3ZD";
                break;
            case "nzlo":
                gtmID = window.location.host === "connect.worldvision.org.nz" ? "GTM-M5CHS8TS" : "GTM-NFDKS3HX";
                break;
        }
        return gtmID;
    } catch (exp) {
        // TODO : Error should be handled through DB logs or analytics
        console.log(exp);
    }
}